import {
    ActionsUnion,
    createAction,
} from "../../../components/reducer/actionHelpers";

export enum messageCheckerActionNames {
    GET_UNREAD = "GET_UNREAD",
    UPDATE_UNREAD = "UPDATE_UNREAD",
}

export const creators = {
    getUnread: () => createAction(messageCheckerActionNames.GET_UNREAD),
    updateUnreadCount: (count: number) =>
        createAction(messageCheckerActionNames.UPDATE_UNREAD, { count }),
};

export type MessageCheckerActionTypes = ActionsUnion<typeof creators>;
